import { useMemo } from 'react';
import { getCategoryQuerySlug } from '@/helpers/utils/getCategoryFromSlug';
import { getSelectedDivision } from '@/helpers/utils/siteUtils';
import { ProductListingContextType } from '../context/productListingContext';
interface OptionItem {
  label: string;
  value: string;
}
interface Option {
  optionIndex: string;
  optionName: string;
}
export const useProductListingContext = (
  searchQuery: string,
  data: any,
  slug?: string,
): { contextValue: ProductListingContextType } => {
  const colorsForBadge = {
    discount: data?.discountPercentageOff,
    new: data?.new,
    bestSeller: data?.bestSeller,
    upto5x: data?.upto5x,
  };

  const categorySlug = getCategoryQuerySlug(slug);
  const currentSlectedSite = `${getSelectedDivision() ?? 'ZB'}Site`;

  const sortByOptions: OptionItem[] = useMemo(() => {
    if (!data || !data.sortBy) return [];

    const updatedSortByOptions = data.sortBy.map((option: Option) => {
      const [prefix, suffix] = option.optionIndex.split('ZBSite');
      const updatedOptionIndex = `${prefix}${currentSlectedSite}${suffix ? `${suffix}` : ''}`;
      return {
        ...option,
        optionIndex: updatedOptionIndex,
      };
    });

    return updatedSortByOptions.map((option: Option) => ({
      label: option.optionName,
      value: option.optionIndex,
    }));
  }, [data, currentSlectedSite]);

  const contextValue: any = useMemo(
    () => ({
      slug: categorySlug,
      searchQuery,
      sortByOptions: sortByOptions,
      facets: data?.facetNames || [],
      showTopCategories: data?.topCategories || false,
      colorsForBadge,
    }),
    [categorySlug, searchQuery, data, colorsForBadge],
  );

  return { contextValue };
};
